import React, {useEffect} from 'react';
import {HashRouter, Routes, Route, useNavigate} from 'react-router-dom';
import './App.css';
import TopMenuBar from "./components/menu/TopMenuBar";
import GeneralDashboard from './components/GeneralDashboard';
import Login from './components/Login';
import ScheduleAppointment from "./components/ScheduleAppointment";
import {useLocation} from "react-router";
import {useUiStore} from "./stores/useUiStore";
import AppointmentConfirmation from "./components/AppointmentConfirmation";

function AppRoutes() {
    const hasRedirected = React.useRef(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!hasRedirected.current && location.pathname !== '/') {
            hasRedirected.current = true;
            navigate('/');
        }
    }, [navigate, window.location]);

    return (
        <>
            <div className="app-right-wrapper">
                <TopMenuBar/>
                <div className="content-area">
                    <main className={`main-content`}>
                        <Routes>
                            <Route path="/" element={<Login/>}/>
                            <Route path="/dashboard" element={<GeneralDashboard/>}/>
                            <Route path="/schedule-appointment" element={<ScheduleAppointment/>}/>
                            <Route path="/appointment-confirmation" element={<AppointmentConfirmation/>}/>
                        </Routes>
                    </main>
                </div>
            </div>
        </>
    );

}

function App() {
    const backgroundUrl = useUiStore(state => state.backgroundUrl);
    return (
        <div className="UCDSchedulerWrapper"
            style={{
                background:`url(${backgroundUrl}) no-repeat`,
                backgroundColor:'#fff3e6'
            }}
        >
            <HashRouter>
                <AppRoutes />
            </HashRouter>
        </div>
    );
}

export default App;